module.exports = __webpack_public_path__ + "static/media/Tula.ddad66a0.png";